var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnSearchGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0 -0.000488281)",
    fill: "white",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7559 14.2544H14.9659L14.6859 13.9844C15.6659 12.8444 16.2559 11.3644 16.2559 9.75439C16.2559 6.16439 13.3459 3.25439 9.75586 3.25439C6.16586 3.25439 3.25586 6.16439 3.25586 9.75439C3.25586 13.3444 6.16586 16.2544 9.75586 16.2544C11.3659 16.2544 12.8459 15.6644 13.9859 14.6844L14.2559 14.9644V15.7544L19.2559 20.7444L20.7459 19.2544L15.7559 14.2544ZM9.75586 14.2544C7.26586 14.2544 5.25586 12.2444 5.25586 9.75439C5.25586 7.26439 7.26586 5.25439 9.75586 5.25439C12.2459 5.25439 14.2559 7.26439 14.2559 9.75439C14.2559 12.2444 12.2459 14.2544 9.75586 14.2544Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSearchGray);
export default __webpack_public_path__ + "static/media/icn_search_gray.cee33e129be88c3ae2c49f60d721caed.svg";
export { ForwardRef as ReactComponent };